// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hidden {\n  display: none !important; }\n\n.containerButton {\n  display: flex;\n  justify-content: space-between; }\n", "",{"version":3,"sources":["webpack://src/pages/Userblock/style.scss"],"names":[],"mappings":"AAAA;EACI,wBAAsB,EAAA;;AAE1B;EACG,aAAa;EACb,8BAA8B,EAAA","sourcesContent":[".hidden{\n    display:none!important;\n}\n.containerButton{\n   display: flex;\n   justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
